export default function reloadAd() {
  const ad = document.querySelector('ins');
  if (ad) {
    ad.removeAttribute('data-adsbygoogle-status');
    (window.adsbygoogle = window.adsbygoogle || []).push({});
  }
}



// WEBPACK FOOTER //
// ./src/lib/reloadAd.js